export default "__VITE_ASSET__11cc06a1__"